import React from 'react';
import { Link } from 'react-router-dom';
import BotPageLayout from '../../components/BotPageLayout';
import { IconCode, IconBug, IconExplain, IconOptimize, IconGlobe, IconArrowRight } from '../../components/Icons';
import './CodeAssist.css';

const HIGHLIGHTS = [
  { Icon: IconBug,      title: 'Debug Code',        desc: 'Paste broken code and get an instant explanation of the bug plus a corrected version.' },
  { Icon: IconExplain,  title: 'Explain Snippets',  desc: 'Understand what any code does with clear, plain-English explanations.' },
  { Icon: IconOptimize, title: 'Optimise',           desc: 'Get concrete suggestions to make your code faster, cleaner, and more efficient.' },
  { Icon: IconGlobe,    title: '20+ Languages',      desc: 'Python, JavaScript, TypeScript, Rust, Go, Java, C++, and many more.' },
];

const CODE_LINES = [
  { n:1, tokens: [{ t:'kw', v:'def ' }, { t:'fn', v:'safe_divide' }, { t:'pl', v:'(a, b):' }] },
  { n:2, tokens: [{ t:'kw', v:'  if ' }, { t:'pl', v:'b == 0: ' }, { t:'kw', v:'return ' }, { t:'num', v:'None' }] },
  { n:3, tokens: [{ t:'kw', v:'  return ' }, { t:'pl', v:'a / b' }] },
];

function FixPreview() {
  return (
    <div className="ca-fix-preview" aria-hidden="true">
      <div className="ca-fix-preview__bar">
        <span className="ca-fix-dot" style={{ background: '#ff5f57' }} />
        <span className="ca-fix-dot" style={{ background: '#febc2e' }} />
        <span className="ca-fix-dot" style={{ background: '#28c840' }} />
        <span className="ca-fix-preview__lang">python</span>
      </div>
      <div className="ca-fix-preview__body">
        {CODE_LINES.map(({ n, tokens }) => (
          <div key={n} className="ca-fix-line">
            <span className="ca-fix-line__num">{n}</span>
            {tokens.map((tok, i) => (
              <span key={i} className={`tok tok--${tok.t}`}>{tok.v}</span>
            ))}
          </div>
        ))}
      </div>
      <div className="ca-fix-preview__note">
        <span className="ca-fix-badge">Fixed</span>
        Zero-division guard added on line 2
      </div>
    </div>
  );
}

export default function CodeAssistHome() {
  return (
    <BotPageLayout
      botName="Code Assist"
      botSlug="code-assist"
      botIcon={<IconCode size={28} color="var(--blue-dark)" />}
      botTagline="Write, debug, and optimise code without leaving your Discord server."
    >
      <div className="container">
        <div className="ca-hero animate-fade-up">
          <div className="ca-hero__text">
            <span className="eyebrow">Code Assist</span>
            <h2 className="section-title">Coding help,<br />right in Discord.</h2>
            <div className="rule" />
            <p className="section-body">
              Launched in 2026, Code Assist brings AI-powered coding assistance directly
              to your Discord server — powered by a custom AI model built and
              managed by PERM Systems.
            </p>
            <div className="ca-hero__cta">
              <Link to="/code-assist/invite"   className="btn btn--primary btn--lg">
                Invite Bot <IconArrowRight size={15} />
              </Link>
              <Link to="/code-assist/features" className="btn btn--outline btn--lg">See Features</Link>
            </div>
          </div>
          <FixPreview />
        </div>

        <div className="ca-highlights">
          {HIGHLIGHTS.map(({ Icon, title, desc }, i) => (
            <div key={title} className={`ca-highlight animate-fade-up delay-${i + 1}`}>
              <div className="icon-wrap icon-wrap--sm"><Icon size={18} /></div>
              <div>
                <h4>{title}</h4>
                <p>{desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="ca-cta-strip animate-fade-up">
          <p>Ready to add Code Assist to your server?</p>
          <Link to="/code-assist/invite" className="btn btn--dark">Invite Now</Link>
        </div>
      </div>
    </BotPageLayout>
  );
}